import React from "react";
import { Navigate } from "react-router-dom";
import useQueryParams from "../../hooks/use-query-params";

const Message = ({ message }) => (
    <section>
        <p>{message}</p>
    </section>
);

const Checkout = () => {
    const query = useQueryParams();
    const success = query.get("success");
    let sessionId;
    let message = "";
    if (success) {
        sessionId = query.get("session_id");
    }
    const canceled = query.get("canceled");
    if (canceled) {
        message = "Order canceled -- continue to shop around and checkout when you're ready.";
        return <Navigate to="/upgrade" />;
    }

    if (!success && message === "") {
        return <Navigate to="/upgrade" />;
    }
    if (success && sessionId !== "") {
        return <Navigate to="/subscription" />;
    }
    return <Message message={message} />;
};

export default Checkout;
